import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/notifications/Page";

export const PATH = "/settings/notifications";

function Home() {
	return (
		<>
			<NskHead title="通知設定" />
			<Component />
		</>
	);
}

export default Home;
